<template>
  <div class="t5quicksearch">
      <form class="t5quicksearch-form">
        <div class="row">

            <!-- Location -->
            <div class="column medium-3 text-center">
                <typeahead ref="ta"
                    :source="filteredLocations"
                    :placeholder="$translate('location-region')"
                    :location="location"
                    :start-at="2"
                    @locSelected="setLocation"
                    @clearLocation="clearLocation"
                >

                </typeahead>
            </div>

            <!-- Checkin/Checkout dates -->
            <div class="column medium-2 text-center">
                <datetime
                    v-model="checkin"
                    type="date"
                    :auto="true"
                    :placeholder="$translate('arrival')"
                    :phrases="{ok: $translate('date-ok'), cancel: $translate('date-cancel')}"
                    :week-start="1"
                    :min-datetime="minCheckin"
                    :format="$translate('date-format')"
                >
                <template slot="before"><i class="fa fa-calendar"></i></template>
            </datetime>
            </div>
            <div class="column medium-2 text-center">
                <datetime
                    v-model="checkout"
                    type="date"
                    :auto="true"
                    placeholder="$translate('departure')"
                    :phrases="{ok: $translate('date-ok'), cancel: $translate('date-cancel')}"
                    :week-start="1"
                    :min-datetime="minCheckout"
                    :format="$translate('date-format')"
                >
                <template slot="before"><i class="fa fa-calendar"></i></template>
                </datetime>
            </div>

            <!-- Guests -->
            <div class="column medium-3 text-center">
                <input type="text" readonly
                    @click="showUnitsPanel" :value="guestsStr"/>
                <transition-group name="vdatetime-fade" tag="div" class="unitsPanel">
                    <div key="overlay" v-if="isOpen" class="vdatetime-overlay" @click.self="hideUnitsPanel"></div>
                    <div key="popup" v-if="isOpen" class="room-container">

                        <Room v-for="(u, n) in units"
                            :idx="n"
                            :num-adults="u.adults"
                            :children-ages="u.children"
                            @unitChanged="updUnit">
                            <button type="button" class="delUnit"
                                v-if="units.length > 1"
                                @click="delUnit(n)"
                                :title="$translate('unit-delete')">
                                    <i class="fa fa-trash"></i>
                                    <span v-translate>unit-delete</span>
                            </button>
                        </Room>

                        <div class="addUnit">
                            <button v-if="units.length < 3" type="button" @click="addUnit">
                                <i class="fa fa-plus"></i> <span v-translate>unit-add</span>
                            </button>

                        </div>

                        <button type="button" class="button primary expanded closeUnitConfig" @click="hideUnitsPanel" v-translate>unit-set</button>
                    </div>


                </transition-group>
            </div>

            <!-- Submit Button -->
            <div class="column medium-2 text-center">
                <button type="button" class="primary button start" :disabled="disabled" @click="startSearch">
                    <i class="fa fa-search"></i> <span v-translate>search</span>
                </button>
            </div>
        </div>
    </form>

    <!-- Tosc5 search result panel component -->
    <feratelsearch ref="feratelsearch"
        :target="target"
        appId="231d342c-17fe-4890-8ff9-f83e2107dc3f"
        appName="KAERNTEN"
        :locationId="selectedLocation"
        :locationType="selectedType"
        :units="units"
        :dates="{checkin: checkin, checkout: checkout}"
        :lang="$translate('locale')"
    >...</feratelsearch>
  </div>
</template>

<script>
import Typeahead from './components/Typeahead'
import Feratelsearch from './components/Feratelsearch'
import Room from './components/Room'
import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'
import 'vue-datetime/dist/vue-datetime.css'
import { weekstart } from 'weekstart'
import moment from 'moment'
import locations from './assets/data_kw.json'

export default {
  name: 'T5quicksearch',
  components: {
    Typeahead,
    Datetime,
    Feratelsearch,
    Room
  },
  data() {
      return {
          target: null,
          locations: locations,
          filteredLocations: locations,
          locFilter: [],
          unitsDropdownId: 'unitsDropdown',
          selectedLocation: '',
          selectedType: '',
          checkin: this.getNextWeekStart().format(),
          checkout: this.getNextWeekEnd().format(),

          units: [],

          location: null,
          roomIdx: 0,
          isOpen: false
      }
  },

  methods: {
      setLocation: function(loc) {
          if(loc.locIdentity) {
              this.selectedLocation = loc.locIdentity
          }
          if(loc.Typ) {
              this.selectedType = loc.Typ
          }
      },

      clearLocation: function (evt) {
          this.selectedLocation = ''
          this.selectedType = ''
      },

      showUnitsPanel: function (event) {
        event.target.blur()

        this.isOpen = true
      },

      hideUnitsPanel: function (evt) {
          this.isOpen = false
      },

      startSearch: function (evt) {
          this.$refs.feratelsearch.search()
          this.hideUnitsPanel()
      },

      filterLocations: function (filterValues) {
        if (filterValues.length > 0) {
            this.filteredLocations = this.locations.filter(i => { return filterValues.includes(i.locIdentity)} )
        } else {
            this.filteredLocations = this.locations
        }
        this.$refs.ta.items = this.filteredLocations
      },

        getNextWeekStart: function () {
            var today = moment();
            var daystoMonday = 0 - (today.isoWeekday() - 1) + 7;
            var nextMonday = today.add('days', daystoMonday);

            return nextMonday;
        },

        getNextWeekEnd: function () {
            var nextMonday = this.getNextWeekStart();
            var nextSunday = nextMonday.add('days', 6);

            return nextSunday;
        },

        addUnit: function () {
            this.units.push({
                adults: 2,
                children: []
            });
        },

        delUnit: function (idx) {
            if (this.units.length > idx) {
                this.units.splice(idx, 1)
            }
        },

        updUnit: function (data) {
            if (this.units.length > data.idx) {
                this.$set(this.units, data.idx, {adults: data.adults, children: data.children})
            }
        }


  },

  watch: {

      locFilter: function(newVal, oldVal) {
          this.filterLocations(newVal)
      },
      checkin: function(newVal, oldVal) {
          if (typeof this.checkout !== 'string' || moment(this.checkout).diff(newVal, 'day') < 1) {
              this.checkout = moment(newVal).add(1, 'day').format()
          }
      },
      location: function(newVal, oldVal) {
          this.$refs.ta.location = newVal
          this.$refs.feratelsearch.location = newVal
      }
  },

  computed: {
      guestsStr: function (){
          let str = "";
          let adults = 0;
          let children = 0;
          this.units.forEach(unit => {
              adults += unit.adults
              if (Array.isArray(unit.children)) children += unit.children.length
          })

		  if(adults + children == 0) {
			  return this.$translate('guests');
		  }
		  if(adults > 0) {
			  if(adults == 1) {
				  str += '1 ' + this.$translate('adult')
			  } else {
				  str = adults + ' ' + this.$translate('adults')
			  }
		  }

		  if(children > 0 && str.length > 0) {
			  str += ", "
		  }

		  if(children > 0) {
			  if(children == 1) {
				  str += '1 ' + this.$translate('child')
			  } else {
				  str += children + ' ' + this.$translate('children')
			  }
		  }

		  return str;
    },

    disabled: function () {

        if (this.checkin === null || this.checkout === null) return true

        for (var i=0; i < this.units.length; i++) {
            if (this.units[i].adults == 0) return true // at least 1 adult per unit is required

            if (Array.isArray(this.units[i].children)) {
                for (var j=0; j < this.units[i].children.length; j++) {
                    if (this.units[i].children[j] === null) return true // an age value for every child is required
                }
            }
        }


    },

    minCheckin: function () {
        return moment().format()
    },

    minCheckout: function () {
        if (typeof this.checkin !== 'string') return moment().add(2, 'day').format()
        return moment(this.checkin).add(1, 'day').format()
    },

    noGuests: function () {
        let hasGuests = false
        this.units.forEach(element => {
            if (element.adults > 0) hasGuests = true;
            if (Array.isArray(element.children) && element.children.length > 0 ) hasGuests = true;
        });
        return !hasGuests
    }

  },

  adults: function() {
      let sum = 0;
      this.units.forEach(element => {
          sum += element.adults
      });
  },

  numChildren: function() {
      let  sum = 0;
      this.units.forEach(element => {
          sum += element.children.length
      });
  },

  mounted: function() {
      this.unitsDropdownId = 'unitsDropdown-' + Math.floor(Math.random()*10000)
      this.filterLocations(this.locFilter);
      Settings.defaultLocale = this.$translate('locale')
      this.addUnit()
  }
}
</script>

<style lang="scss" >
@import 'assets/scss/T5quicksearch.scss';

</style>



// WEBPACK FOOTER //
// src/T5quicksearch.vue